import PageLayout from 'pages/InstructorAssignmentFeedback/PageLayout';
import PageProvider from 'pages/InstructorAssignmentFeedback/PageProvider';

const InstructorAssignmentFeedbackPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default InstructorAssignmentFeedbackPage;
